import * as actionTypes from '../constants/actionTypes';
export var initialState = {
    isRowOverlayOn: false,
    isColumnOverlayOn: false,
};
export default function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.TOGGLE_ROW_OVERLAY:
            return {
                isRowOverlayOn: !state.isRowOverlayOn,
                isColumnOverlayOn: state.isColumnOverlayOn,
            };
        case actionTypes.TOGGLE_COLUMN_OVERLAY:
            return {
                isRowOverlayOn: state.isRowOverlayOn,
                isColumnOverlayOn: !state.isColumnOverlayOn,
            };
        default:
            return state;
    }
}
